__turbopack_context__.v({
  "blurred": "w-BPCG_blurred",
  "image": "w-BPCG_image",
  "linkOrClick": "w-BPCG_linkOrClick",
  "top": "w-BPCG_top",
});
